import React from 'react';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import type { Route } from 'react-resource-router';
import { withRouter } from 'react-resource-router';
import { JiraAdminPermissionWrapper } from 'utils/routes';
import Spinner from '@atlaskit/spinner';
import { EditLayoutResource } from '@atlassian/admin-layout/src/ui/hub-edit-layout/resources/edit-layout/resource';

const AsyncHelpCenterEditDetailsPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-edit-details-page" */ '@atlassian/help-centers-management/src/ui/edit-helpcenter/index'
        ).then(({ HelpCenterEditDetails }) => HelpCenterEditDetails)
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageProjectsPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-manage-projects-page" */ '@atlassian/admin-layout/src/ui/manage-projects/index'
        ).then(({ HelpCenterManageProjects }) => HelpCenterManageProjects)
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageCustomPagesPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-manage-pages-page" */ '@atlassian/admin-layout/src/ui/manage-pages/index'
        ).then(({ HelpCenterManagePages }) => HelpCenterManagePages)
    ),
    LoadingSkeleton: () => null,
});

const AsyncHubEditLayoutComponent = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-edit-hub-layout-page" */ '@atlassian/admin-layout/src/ui/hub-edit-layout/index'
        ).then(({ HubEditLayout }) => HubEditLayout)
    ),
    LoadingSkeleton: () => <Spinner />,
});

export const helpcenterEditRoute: Route = {
    name: 'edit-details',
    path: '/:helpcenterId/details',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            <AsyncHelpCenterEditDetailsPage />
        </JiraAdminPermissionWrapper>
    )),
};

export const helpcenterManageProjectsRoute: Route = {
    name: 'manage-projects',
    path: '/:helpcenterId/projects',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            <AsyncHelpCenterManageProjectsPage />
        </JiraAdminPermissionWrapper>
    )),
};

export const helpcenterManageCustomPagesRoute: Route = {
    name: 'manage-pages',
    path: '/:helpcenterId/pages',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            <AsyncHelpCenterManageCustomPagesPage />
        </JiraAdminPermissionWrapper>
    )),
};

export const hubEditLayoutRoute: Route = {
    name: 'edit-hub',
    path: '/:helpcenterId/edit-hub/:pageId?',
    exact: true,
    resources: [EditLayoutResource],
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            <AsyncHubEditLayoutComponent />
        </JiraAdminPermissionWrapper>
    )),
};
